import { GTMEventAuth } from '@/fo/api/gtm';

export const EVENT_OPEN_AUTH_MODAL = 'open-auth-modal';
export const EVENT_CLOSE_AUTH_MODAL = 'close-auth-modal';
export const EVENT_SHOW_FORGOT_PASSWORD = 'show-forgot-password';
export const EVENT_SHOW_LOGIN = 'show-login';
export const EVENT_SWITCH_TO_LOGIN_TAB = 'switch-to-login-tab';
export const EVENT_SWITCH_TO_REGISTRATION_TAB = 'switch-to-registration-tab';

export const utilEventAuthModal = {
  open: (referral: GTMEventAuth['referral']) => {
    window.dispatchEvent(
      new CustomEvent(EVENT_OPEN_AUTH_MODAL, { detail: { referral } })
    );
  },

  close: () => {
    window.dispatchEvent(new CustomEvent(EVENT_CLOSE_AUTH_MODAL));
  },

  showForgotPassword: () => {
    window.dispatchEvent(new CustomEvent(EVENT_SHOW_FORGOT_PASSWORD));
  },

  showLogin: (email?: string) => {
    window.dispatchEvent(
      new CustomEvent(EVENT_SHOW_LOGIN, { detail: { email } })
    );
  },

  switchToLoginTab: () => {
    window.dispatchEvent(new CustomEvent(EVENT_SWITCH_TO_LOGIN_TAB));
  },

  switchToRegistrationTab: () => {
    window.dispatchEvent(new CustomEvent(EVENT_SWITCH_TO_REGISTRATION_TAB));
  },

  onOpen: (callback: (referral: GTMEventAuth['referral']) => void) => {
    const handler = (event: Event) =>
      callback((event as CustomEvent).detail.referral);
    window.addEventListener(EVENT_OPEN_AUTH_MODAL, handler);

    return () => {
      window.removeEventListener(EVENT_OPEN_AUTH_MODAL, handler);
    };
  },

  onClose: (callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(EVENT_CLOSE_AUTH_MODAL, handler);

    return () => {
      window.removeEventListener(EVENT_CLOSE_AUTH_MODAL, handler);
    };
  },

  onShowForgotPassword: (callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(EVENT_SHOW_FORGOT_PASSWORD, handler);

    return () => {
      window.removeEventListener(EVENT_SHOW_FORGOT_PASSWORD, handler);
    };
  },

  onShowLogin: (callback: (email?: string) => void) => {
    const handler = (event: Event) =>
      callback((event as CustomEvent).detail.email);
    window.addEventListener(EVENT_SHOW_LOGIN, handler);

    return () => {
      window.removeEventListener(EVENT_SHOW_LOGIN, handler);
    };
  },

  onSwitchToLoginTab: (callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(EVENT_SWITCH_TO_LOGIN_TAB, handler);

    return () => {
      window.removeEventListener(EVENT_SWITCH_TO_LOGIN_TAB, handler);
    };
  },

  onSwitchToRegistrationTab: (callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(EVENT_SWITCH_TO_REGISTRATION_TAB, handler);

    return () => {
      window.removeEventListener(EVENT_SWITCH_TO_REGISTRATION_TAB, handler);
    };
  }
};
